import { Visit } from '@chiroup/core/types/PatientVisit.type';

// Signed notes freeze `detail` on the row; the Yjs copy can be a stale draft.
// Gate on the API's `signed`, not the `_signature` override: right after signing
// `apiVisit` is still the pre-sign fetch.
export const resolveVisitDetail = ({
  apiVisit,
  yjsVisit,
}: {
  apiVisit?: Partial<Visit> | null;
  yjsVisit: Partial<Visit>;
}): Visit['detail'] =>
  apiVisit?.signed ? (apiVisit.detail ?? yjsVisit.detail) : (yjsVisit.detail ?? apiVisit?.detail);
